const rankings = [
  {
    rank: 1,
    title: '《暗夜追踪》',
    meta: '悬疑 / 犯罪',
    score: '9.4',
    trend: 'up',
    hotness: '158.6万',
  },
  {
    rank: 2,
    title: '《长安十二时辰》',
    meta: '古装 / 悬疑',
    score: '9.2',
    trend: 'same',
    hotness: '142.3万',
  },
  {
    rank: 3,
    title: '《星辰大海》',
    meta: '科幻 / 冒险',
    score: '9.0',
    trend: 'up',
    hotness: '128.7万',
  },
  {
    rank: 4,
    title: '《夏日的风》',
    meta: '爱情 / 青春',
    score: '8.8',
    trend: 'up',
    hotness: '115.2万',
  },
  {
    rank: 5,
    title: '《极限营救》',
    meta: '动作 / 灾难',
    score: '8.7',
    trend: 'down',
    hotness: '98.4万',
  },
  {
    rank: 6,
    title: '《山海经异兽录》',
    meta: '动画 / 奇幻',
    score: '8.6',
    trend: 'new',
    hotness: '87.1万',
  },
];

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line text-accent-400',
  down: 'ri-arrow-down-line text-foreground-500',
  same: 'ri-subtract-line text-foreground-500',
  new: 'ri-sparkling-line text-primary-400',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            热播榜单
          </h2>
          <p className="mt-3 text-foreground-400 text-sm">
            本周最受蚂蚁影视用户欢迎的影片
          </p>
        </div>

        <div className="bg-background-50 border border-background-300/30 rounded-xl overflow-hidden">
          <div className="grid grid-cols-12 gap-3 px-5 py-3 text-xs font-medium text-foreground-500 border-b border-background-300/20">
            <span className="col-span-1">排名</span>
            <span className="col-span-5">影片</span>
            <span className="col-span-2 text-center">评分</span>
            <span className="col-span-2 text-center">趋势</span>
            <span className="col-span-2 text-right">热度</span>
          </div>

          {rankings.map((item) => (
            <div
              key={item.rank}
              className="grid grid-cols-12 gap-3 px-5 py-4 items-center border-b border-background-300/10 last:border-b-0 hover:bg-background-200/40 transition-colors cursor-pointer"
            >
              <span className="col-span-1">
                <span
                  className={`inline-flex items-center justify-center w-7 h-7 rounded-lg text-xs font-bold ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-950'
                      : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  {item.rank}
                </span>
              </span>
              <div className="col-span-5 min-w-0">
                <h3 className="text-sm font-medium text-foreground-100 truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.meta}</p>
              </div>
              <span className="col-span-2 text-center text-sm font-semibold text-primary-400">
                {item.score}
              </span>
              <span className="col-span-2 flex justify-center">
                <i className={`text-sm ${trendIcons[item.trend]}`}></i>
              </span>
              <span className="col-span-2 text-right text-xs font-medium text-foreground-400">
                {item.hotness}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}